/** External dependencies */
import { Alert, Button, Collapse, Dropdown, Modal, Scrollspy, Tab } from 'bootstrap';

/** Internal dependencies */
import { forms } from './components/forms';
import { search } from './components/search';
import { throttle } from './utilities/throttleEvents';

window.bootstrapDetectBreakpoint = function () {
    const breakpointNames = ['xl', 'lg', 'md', 'sm', 'xs'];
    let breakpointValues = [];
    for (const breakpointName of breakpointNames) {
        breakpointValues[breakpointName] = window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--breakpoint-' + breakpointName);
    }
    let i = breakpointNames.length;
    for (const breakpointName of breakpointNames) {
        i--;
        if (window.matchMedia('(min-width: ' + breakpointValues[breakpointName] + ')').matches) {
            return breakpointName;
        }
    }
    return null;
};

if (document.readyState !== 'loading') {
    initScript();
} else {
    document.addEventListener('DOMContentLoaded', () => {
        initScript();
    });
}

/*
jQuery('.ct-toggle').click(function () {
    let element = this;
    setTimeout(function () {
        jQuery(element).parent().toggleClass('show');
        jQuery(element).next().toggleClass('show');
        jQuery('body').toggleClass('ct-toggle-open');
    }, 50);
});

jQuery('body').click(function () {
    if (jQuery(this).hasClass('ct-toggle-open')) {
        jQuery('.ct-toggle').parent().removeClass('show');
        jQuery('.ct-toggle').next().removeClass('show');
        jQuery(this).removeClass('ct-toggle-open');
    }
});*/

function initScript() {
    // Init textarea autosize
    forms();
    search();
}
